<template>
  <div class="sidebar">
    <!-- <div class="sidebar-widget style4">
      <h4>Search Here</h4>
      <div class="search-box">
        <div class="form-group">
          <input type="search" placeholder="Search" />
          <button type="submit">
            <i class="ri-search-2-line"></i>
          </button>
        </div>
      </div>
    </div> -->

    <div class="sidebar-widget categories">
      <h4>Echipa medicală</h4>
      <div class="category-box">
        <ul class="list-style">
          <li :class="{ active: isActive('/echipa_medicala/eduard_cocea') }">
            <router-link to="/echipa_medicala/eduard_cocea#echipa_medicala">
              Dr. Eduard Cocea
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>
          <li :class="{ active: isActive('/echipa_medicala/xenia_cocea') }">
            <router-link to="/echipa_medicala/xenia_cocea#echipa_medicala">
              Dr. Xenia Cocea
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>
          <li :class="{ active: isActive('/echipa_medicala/raluca_roman') }">
            <router-link to="/echipa_medicala/raluca_roman#echipa_medicala">
              Dr. Raluca Roman
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>

          <li :class="{ active: isActive('/echipa_medicala/gina_neculaes') }">
            <router-link to="/echipa_medicala/gina_neculaes#echipa_medicala">
              Dr. Gina Neculăeş
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>

          <li :class="{ active: isActive('/echipa_medicala/claudiu_nicolaiev') }">
            <router-link to="/echipa_medicala/claudiu_nicolaiev#echipa_medicala">
              Dr. Claudiu Nicolaiev
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>

          <li :class="{ active: isActive('/echipa_medicala/petronela_pascaru') }">
            <router-link to="/echipa_medicala/petronela_pascaru#echipa_medicala">
              Dr. Petronela Pascaru
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>

          <li :class="{ active: isActive('/echipa_medicala/alexandra_veronica_mengheres') }">
            <router-link to="/echipa_medicala/alexandra_veronica_mengheres#echipa_medicala">
              Dr. Alexandra Veronica Menghereș
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>

          <li :class="{ active: isActive('/echipa_medicala/alexandra_ioana_nastasa') }">
            <router-link to="/echipa_medicala/alexandra_ioana_nastasa#echipa_medicala">
              Dr. Alexandra Ioana Năstasă
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>

          <li :class="{ active: isActive('/echipa_medicala/maria_ciocan') }">
            <router-link to="/echipa_medicala/maria_ciocan#echipa_medicala">
              Psiholog Maria Ciocan
              <i class="ri-arrow-right-line"></i>
            </router-link>
          </li>


        </ul>

      </div>
    </div>

    <!-- <div class="sidebar-widget">
      <h4>Business Hours</h4>
      <div class="schedule-widget">
        <ul class="list-style">
          <li>
            <h6>Mon-Thurs</h6>
            <p>8:00 AM - 5:00 PM</p>
          </li>
          <li>
            <h6>Fri-Sat</h6>
            <p>8:00 AM - 3:00 PM</p>
          </li>
          <li>
            <h6>Sun</h6>
            <p>Closed</p>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "SideBar",

  methods: {
    isActive(path) {
      return this.$route.path === path;
    }
  }
};
</script>